import { useLocation } from 'react-router-dom';

const DEFAULT_PATH = '/';

// Matches EatSignIn::SanitizeReturnToService: relative eat paths only, so sign-in can't send people off-site
export const sanitizeReturnTo = (value: string | null | undefined) => {
  if (!value?.startsWith('/')) return DEFAULT_PATH;
  // Browsers treat "//host" and "/\host" as another host
  // eslint-disable-next-line no-control-regex
  if (value.startsWith('//') || value.includes('\\') || /[\u0000-\u001f\u007f]/.test(value)) return DEFAULT_PATH;

  return value;
};

export const withReturnTo = (path: string, returnTo: string) => (
  returnTo === DEFAULT_PATH ? path : `${path}?return_to=${encodeURIComponent(returnTo)}`
);

export const useReturnTo = () => {
  const { search } = useLocation();
  return sanitizeReturnTo(new URLSearchParams(search).get('return_to'));
};
